/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React, { useState } from 'react';
import { Form } from 'react-bootstrap';
import { useTheme } from '../../../../../../providers/theme';
import * as S from './styles';

export interface ISelectInputProps {
  id: string;
  label: string;
  invalidText: string;
  required: boolean;
  value: string;
  options: {
    label: string;
    value: string;
  }[];
  onCompChange?(item: any, id: string, payload: any): void;
  [key: string]: any;
}

export const SelectInput = (props: ISelectInputProps) => {
  const { id, label, required, value, options, onCompChange } = props;
  const theme = useTheme();

  const onChange = (id: string, event: any) => {
    console.log(`onFormValue Change`, id, value);
    onCompChange && onCompChange(props?.item, id, event?.target?.value);
  };
  return (
    <Form.Group className="formgroup" controlId={id}>
      {label && (
        <S.FormLabel color={theme?.colors?.primary}>
          {label}
          {required && <sup style={{ color: 'red' }}>*</sup>}
        </S.FormLabel>
      )}
      <Form.Select
        className="formcontrol shadow-none"
        onChange={onChange.bind(null, props?.id)}
        required={required}
        defaultValue={value}
      >
        <option aria-disabled>{label}</option>
        {options?.map((item: any) => {
          return (
            <option value={item?.value} className="option">
              {item?.label}
            </option>
          );
        })}
      </Form.Select>
    </Form.Group>
  );
};
